module.exports = __webpack_public_path__ + "img/horizontal_3_7_3009.b33302b6.png";